import { useMutation } from '@tanstack/react-query'

import chatService, {
	BroadcastMessagesDto,
	BroadcastResponse,
} from '../services'

export function useMutationBroadcastMessages() {
	return useMutation<BroadcastResponse, Error, BroadcastMessagesDto>({
		mutationFn: (data) => chatService.broadcastMessages(data),
	})
}
